// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1adE4","label":"Labeled_label__L_Ks7","divider":"Labeled_divider__3YCxT"};